export default function htmlToPlainText(html) {
  const answerElement = document.createElement('div')
  answerElement.innerHTML = html
  return answerElement.textContent || answerElement.innerText || ''
}
